import type { TourSection } from './types';

export const rolesListSections: TourSection[] = [
  {
    id: 'list',
    label: 'Roles y permisos',
    steps: [
      {
        target: '[data-tour="roles-list"]',
        title: 'Roles',
        content:
          'Cada rol agrupa permisos y se asigna a las personas. Los roles se comparten con Effetá Apps, que acepta hasta 50. El rol "full-admin" está protegido: no se puede editar ni eliminar. Un rol que alguien tiene en Effetá Apps tampoco se puede eliminar hasta asignarle otro.',
      },
    ],
  },
  {
    id: 'modules',
    label: 'Qué módulos ve un rol',
    steps: [
      {
        target: '[data-tour="roles-list"]',
        title: 'Módulos que ve este rol',
        content:
          'Al crear o editar un rol, la sección "Módulos que ve este rol" muestra qué secciones del menú lateral verán sus usuarios. Una sección aparece solo si el rol tiene todos sus permisos; si le falta alguno, se indica cuál. Se actualiza apenas marcas o desmarcas un permiso.',
      },
    ],
  },
];
